import { createAsyncThunk } from '@reduxjs/toolkit';

import instance from 'configs/requests';
import { TaskStatus, TaskTriggerEvent } from 'constants/enums';

export const getTasks = createAsyncThunk(
  'tasks/getTasks',
  async (params: { gids?: (string | undefined)[]; uid?: string }) => {
    const allTasks: ITask[] = [];
    const { data: tasksData } = await instance.get('/clinician-gateway/tasks', { params });
    tasksData.forEach((task: ITask) => {
      allTasks.push(task);
    });
    if (params.uid) {
      const { data: tasksTriggersData } = await instance.get(
        '/clinician-gateway/careplan-triggers',
        {
          params: { uid: params.uid, event: TaskTriggerEvent.ON_STATUS_CHANGE }
        }
      );
      tasksTriggersData.forEach((taskTrigger: any) => {
        const triggeredTask = {
          triggerId: taskTrigger.id,
          ...JSON.parse(taskTrigger.itemContent),
          patientInfo: taskTrigger.patientInfo,
          trigger: { details: taskTrigger.details, event: taskTrigger.event },
          status: TaskStatus.ACTIVE
        } as ITask;
        allTasks.push(triggeredTask);
      });
    }
    return allTasks;
  }
);

export const getTaskTriggers = createAsyncThunk(
  'tasks/getTaskTriggers',
  async (params: { uid: string; event: string }) => {
    const { data } = await instance.get('/clinician-gateway/careplan-triggers', { params });
    return data.map((taskTrigger: any) => JSON.parse(taskTrigger.itemContent)) as ITask[];
  }
);

export const getTasksForTemplate = createAsyncThunk(
  'tasks/getTasksForTemplate',
  async (params: { gid?: string; templateId?: string }) => {
    const { data } = await instance.get(
      `/clinician/2.0.0/CarePlanTemplate/${params.templateId}/content?group_id=${params.gid}`
    );
    return data.carePlanTemplate.tasks as ITask[];
  }
);

export const fetchInterventions = createAsyncThunk(
  'tasks/getInterventions',
  async (orgGid: string) => {
    const { data } = await instance.get('/clinician-gateway/tasks/interventions', {
      params: { gid: orgGid }
    });
    return data as { managed: IIntervention[]; userCreated: IIntervention[] };
  }
);
